module.exports = __webpack_public_path__ + "img/noID.a8283a2e.svg";